<script>
    import {onMount} from "svelte";
    import {navigate} from "svelte-routing";
    import {decode} from "html-entities";

    export let model_root;
    export let mid;
    export let edit = false;
    export let cid = 0;
    export let ctype = "DEFAULT";

    let cname, cauthor, ctext;

    if (edit === true) {
        loadContentItem(cid);
    }

    $ : menuItem = loadMenuItem(mid);

    let rendered = false;
    onMount(() => {
        let waitCKEDITOR = setInterval(() => {
            if (window.CKEDITOR) {
                clearInterval(waitCKEDITOR);
                CKEDITOR.replace('ctext', {
                    width: '100%',
                    height: '300',
                    on: {
                        instanceReady: () => {
                            if (edit === true && ctext !== undefined && ctext.length !== 0) {
                                CKEDITOR.instances['ctext'].setData(ctext);
                            }
                            rendered = true;
                        }
                    }
                });
            }
        }, 150);
    });

    async function loadContentItem(id) {
        await fetch(model_root + 'shared/contents/load_content_details.php?cid=' + id, {
            method: "GET"
        })
            .then(response => response.json())
            .then(item => {
                cname = decode(item[0].cname);
                cauthor = decode(item[0].cauthor);
                ctext = item[0].ctext;

            });
    }

    function loadMenuItem(id) {
        return fetch(model_root + 'shared/menu/load_menu_item.php?mid=' + id, {
            method: "GET"
        })
            .then(response => response.json());
    }

    function uploadItem(publish = true, pin = false) {
        let ctext = CKEDITOR.instances.ctext.getData();

        const data = new FormData();
        data.append("cmenu", mid);
        data.append("cname", cname);
        data.append("ctext", ctext);
        data.append("cauthor", cauthor);
        data.append("ctype", ctype);
        data.append("cvisible", publish.toString());
        data.append("cpinned", pin.toString());

        fetch(model_root + 'admin/contents/upload_content.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    showSuccessMsg("Inhalt wurde erfolgreich erstellt! Sie werden automatisch weitergeleitet.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function updateItem() {
        let ctext = CKEDITOR.instances.ctext.getData();

        const data = new FormData();
        data.append("cid", cid);
        data.append("cname", cname);
        data.append("ctext", ctext);
        data.append("cauthor", cauthor);

        fetch(model_root + 'admin/contents/update_content.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    showSuccessMsg("Inhalt wurde erfolgreich aktualisiert! Sie werden automatisch weitergeleitet.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    let errorMsg = "";
    let successMsg = "";

    function showSuccessMsg(msg) {
        errorMsg = "";
        successMsg = msg;
        setTimeout(() => {
            navigate("/menu-item/" + mid, {replace: true});
        }, 2500);
    }

    function showErrorMsg(msg) {
        errorMsg = msg;
        window.scrollTo(0, 0);
    }

    function hideErrorMsg() {
        errorMsg = "";
    }

    function cancelAndNavigateBack() {
        navigate("/menu-item/" + mid, {replace: true});
    }

</script>

{#await menuItem}
    <p class="alert alert-light">
        <i class="fas fa-circle-notch fa-spin"></i> Lade Inhalte...
    </p>
{:then data}
    <h4 class="text-muted">{@html data[0].mname}</h4>
    {#if cname === undefined || cname.length === 0}
        <h2 class="mb-4">Neuer Inhalt</h2>
    {:else}
        <h2 class="mb-4">{@html cname}</h2>
    {/if}

    {#if ctype === "FORM_CONTENT"}
        <div class="alert alert-info mb-4">
            <i class="fas fa-info-circle"></i> Die Formularinhalte können in einem separaten Schritt erstellt werden.
        </div>
    {/if}

    {#if ctype === "MAP_CONTENT"}
        <div class="alert alert-info mb-4">
            <i class="fas fa-info-circle"></i> Die Karte kann in einem separaten Schritt eingerichtet werden.
        </div>
    {/if}

    <form on:submit|preventDefault on:reset|preventDefault={cancelAndNavigateBack}>
        <div class="row mb-3">
            <label for="cname" class="col-sm-2 col-form-label">Titel</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="cname" bind:value={cname}>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col">
                <textarea id="ctext"></textarea>
                {#if !rendered}
                    <p class="alert alert-light">
                        <i class="fas fa-circle-notch fa-spin"></i> Lade Editor...
                    </p>
                {/if}
            </div>
        </div>
        <div class="row mb-3">
            <label for="cauthor" class="col-sm-2 col-form-label">Verfasser</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="cauthor" bind:value={cauthor}>
            </div>
        </div>

        {#if errorMsg.length > 0}
            <div class="alert alert-danger" role="alert">
                {errorMsg}
                <br>
                <a href="#" on:click={hideErrorMsg}>Fehlermeldung verbergen</a>
            </div>
        {/if}
        {#if successMsg.length > 0}
            <div class="alert alert-success" role="alert">
                <i class="fas fa-circle-notch fa-spin"></i>
                {successMsg}
            </div>
        {/if}


        <br>
        {#if !edit}
            <button type="submit" class="btn btn-primary" on:click={() => { uploadItem() }}><i
                    class="fas fa-upload"></i> Veröffentlichen
            </button>
            <br>
            <small>Veröffentlichen Sie den Inhalt im Menü "{data[0].mname}".
                {#if ctype === "TEXT_CONTENT"}
                    Bilder und eventuelle Dateien können in einem nächsten Schritt hinzugefügt werden.
                {/if}
            </small><br><br>
            {#if 1 === 0}
                <button type="submit" class="btn btn-primary" on:click={() => { uploadItem(true, true) }}><i
                        class="fas fa-thumbtack"></i> Veröffentlichen und Anpinnen
                </button>
                <br>
                <small>Veröffentlichen Sie den Inhalt im Menü "{data[0].mname}". Der Inhalt wird anschließend direkt an
                    den oberen Bereich der Seite angeheftet.
                    {#if ctype === "TEXT_CONTENT"}
                        Bilder und eventuelle Dateien können in einem nächsten Schritt hinzugefügt werden.
                    {/if}
                </small><br><br>
            {/if}
            <button type="submit" class="btn btn-primary" on:click={() => { uploadItem(false, false) }}><i
                    class="fas fa-upload"></i> Hochladen und nicht veröffentlichen
            </button>
            <br>
            <small>Der Inhalt wird im Menü "{data[0].mname}" hochgeladen, ist aber nicht auf der Seite sichtbar, solange
                er nicht veröffentlicht wird. Der Inhalt kann zu einem späteren Zeitpunkt jederzeit nachträglich
                veröffentlicht werden.
                {#if ctype === "TEXT_CONTENT"}
                    Bilder und eventuelle Dateien können in einem nächsten Schritt hinzugefügt werden.
                {/if}
            </small><br><br>
        {:else}
            <button type="submit" class="btn btn-primary" on:click={updateItem}><i class="fas fa-edit"></i>
                Aktualisieren
            </button>
            <br>
            <small>Der Inhalt "{cname}" wird aktualisiert. Eventuelle Bilder und Anhänge, sowie Formulare bleiben erhalten.</small><br><br>
        {/if}
        <button type="reset" class="btn btn-secondary"><i class="far fa-trash-alt"></i> Abbrechen</button>
        <br>
        <small>Der Inhalt wird nicht hochgeladen und alle Änderungen gehen verloren.</small><br><br>
    </form>

{:catch error}
    <p style="color: red">{error.message}</p>
{/await}

<style>
    #ctext {
        display: none;
    }
</style>
